import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayRatingSubmittedPayload {
  shiftId: string;
  professionalId?: string;
}

/**
 * Fires when an office clicks the CTA that completes the rating step of the
 * end-of-day flow.
 * Event: dental_portal:end_of_day:rating_submitted
 */
export function fireEndOfDayRatingSubmitted(payload: IEndOfDayRatingSubmittedPayload): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:rating_submitted', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
  });
}
